import { useContext } from 'react';

import { PermissionContext } from './PermissionContext';
import type { PermissionContextValue } from './PermissionContext';

/** Access the current user and the typed `hasPermission` check. */
export const usePermission = (): PermissionContextValue => {
  const ctx = useContext(PermissionContext);
  if (!ctx) throw new Error('usePermission must be used within a PermissionProvider');
  return ctx;
};
